import React, { Suspense } from 'react';
import { ErrorNamespaceProvider, BlockingErrorBoundary } from '@edreamsodigeo/frontend-core';
import Funnel from './Funnel';
export const RegisterFunnel = () => /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
  namespace: "shell_funnel_register"
}, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
  name: "funnel_register"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(Funnel, null))));